import React from 'react'
import styled from 'styled-components'
import { Room } from '../../../model/Device/Room'
import { getTranslations, ITranslations } from '../../../services/translations'
import { useConfigContext } from '../../App/App'
import Card from './Card/Card'
import DoorBase from './Content/Room/Door/Door'

const Wrapper = styled(Card)`
  flex-direction: column;
  padding: 0 12.5rem 0 12.5rem;

  @media screen and (orientation: portrait) {
    padding: 0 2.5rem 0 2.5rem;
  }
`

const Door = styled(DoorBase)`
  align-items: center;
  font-size: 10rem;
  margin: 4.5rem 0 8rem 0;

  img {
    height: 9rem;
  }
`

const FreeRoomText = styled.div`
  margin: auto 13rem;
  color: #52a840;
  font-size: 10rem;
  font-weight: bold;
  text-align: center;
`

const NoEvent = () => {
  const { device, freeRoomTitle, langCode } = useConfigContext()
  const translations: ITranslations = getTranslations(langCode)
  const showDoor = device && !device.router && device.rooms.length > 0
  const getDoorNumbers = (rooms: Room[]) => rooms.map((room: Room): string => room.door).join('/')
  const freeRoomText = freeRoomTitle ? freeRoomTitle : translations.roomFree

  return (
    <Wrapper>
      {showDoor && <Door doorNumber={getDoorNumbers(device.rooms)}/>}
      <FreeRoomText>
        {freeRoomText}
      </FreeRoomText>
    </Wrapper>
  )
}

export default NoEvent
